import {Component, h, Listen, Prop, State} from '@stencil/core';

@Component({
  tag: 'nest-shell-panel-item',
  styleUrl: 'nest-shell-panel-item.scss',
  shadow: true,
})
export class NestShellPanelItem {
  @Prop() icon: string;
  @Prop() text: string;
  @Prop() active: boolean;
  @Prop() primary: boolean;
  @Prop({ mutable: true, reflect: true}) show: boolean;

  @State() expanded: boolean;

  @Listen('nestPanelExpanded', { target: 'window' })
  public panelExpandedHandler(event: CustomEvent<boolean>) {
    if(this.show) {
      this.expanded = this.show;
      return;
    }
    this.expanded = event.detail
  }

  componentWillLoad() {
    if(this.show) {
      this.expanded = this.show;
      return;
    }
    // this.expanded = JSON.parse(localStorage.getItem('shell_panel_expanded') || 'false') || false;
  }

  render() {
    const {icon, text, active, expanded, primary} = this;
    return (
      <ul>
        <li
          class={
            `relative flex items-center py-2 px-2 font-medium rounded-lg cursor-pointer group
            ${primary ? 'my-3' : 'my-1'}
            ${active
              ? "text-blue-600 bg-blue-50 cursor-default"
              : "hover:bg-gray-50 hover:text-blue-600 text-gray-600"
            }
          `}
        >
          {icon &&
            <nest-icon name={icon} class={`w-6 ${active ? 'fill-blue-600' : 'fill-gray-600 group-hover:fill-blue-600'}`}/>
          }

          {expanded ? (
            <span class={`transition-all w-52 ml-3 text-sm`}>{text}</span>
          ) : (
            <div class="absolute left-full z-10 px-2 py-1 ml-6 bg-gray-900 text-gray-50 text-sm rounded invisible opacity-20 -translate-x-3 transition-all group-hover:visible group-hover:opacity-100 group-hover:translate-x-0">
              {text}
            </div>
          )}
        </li>
      </ul>
    );
  }
}
